import { render } from "./LienMultiVIPView.vue?vue&type=template&id=ea460e94"
import script from "./LienMultiVIPView.vue?vue&type=script&lang=js"
export * from "./LienMultiVIPView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__